import QuestionContent from './question-content';
import Segment from '../../shared/segment';
import QuestionTitle from './question-title';
import {
  QuestionOverviewType,
  StudentQuestionBehaviorStateType
} from '../../../api/student-question';
import BehaviorState from './behavior-state';

export type QuestionPropsType = {
  questionNumber: number;
  questionCount: number;
  question: QuestionOverviewType;
  studentQuestionId: number;
  selectedOptionId: number | null;
  behaviorState: StudentQuestionBehaviorStateType;
  toggleShowBehaviorStateModal: () => void;
};

function Question({
  questionNumber,
  questionCount,
  question,
  studentQuestionId,
  selectedOptionId,
  behaviorState,
  toggleShowBehaviorStateModal
}: QuestionPropsType) {
  return (
    <div>
      <Segment noMargin color={selectedOptionId ? 'blue' : 'gray'} className='my-1'>
        <div className='flex items-center justify-between'>
          <QuestionTitle questionNumber={questionNumber} questionCount={questionCount} />
          {!selectedOptionId && (
            <BehaviorState
              studentQuestionId={studentQuestionId}
              behaviorState={behaviorState}
              openModal={toggleShowBehaviorStateModal}
            />
          )}
        </div>
        <div className='mx-3'>
          <QuestionContent
            question={question}
            studentQuestionId={studentQuestionId}
            selectedOptionId={selectedOptionId}
          />
        </div>
      </Segment>
    </div>
  );
}

export default Question;
